import { render, staticRenderFns } from "./ExpenseAnalyst.vue?vue&type=template&id=2640ad5e&scoped=true&"
import script from "./ExpenseAnalyst.vue?vue&type=script&lang=js&"
export * from "./ExpenseAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseAnalyst.vue?vue&type=style&index=0&id=2640ad5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640ad5e",
  null
  
)

export default component.exports